module.exports = __webpack_public_path__ + "static/media/fill.f7f8b961.svg";